import { enqueueSnackbar } from "notistack";

export const useSubmitHandwrittenFile = (
  assignmentQuestion,
  fileUploader,
  ApiClient,
) => {
  const submitHandwrittenFile = async (student) => {
    if (!fileUploader.file) {
      enqueueSnackbar("No file selected!", { variant: "error" });
      return;
    }

    try {
      const tempFilePreview = {
        img: URL.createObjectURL(fileUploader.file),
        type: "pdf",
        name: fileUploader.file.name,
        file: fileUploader.file,
      };

      const response = await ApiClient.assignment.submitHandwrittenPDF({
        assignmentQuestion: assignmentQuestion.id,
        pdfFile: tempFilePreview,
        student: student.id,
        markOnSubmit: true, // always mark on submit
      });

      if (response.success) {
        enqueueSnackbar("PDF submitted!", {
          variant: "success",
          autoHideDuration: 3000,
        });
        fileUploader.setIdentifier({});
      } else {
        enqueueSnackbar(response.message || "Error submitting!", {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      console.error("Failed to submit PDF", error);
      enqueueSnackbar("Error submitting!", {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  };

  return { submitHandwrittenFile };
};
